export const Skus = {
  BPUSkuCode: 'BPU',
  CPUSkuCode: 'CPU',
  K8SkuCode: 'K8P',
  K8FamilySkuCode: 'K8P',
  HighSchoolSkuCode: 'HSP',
  K12SkuCode: 'K12P',
  K12FamamilySkuCode: 'K12P',
  ADLSkuCode: 'ADL',
  MSPSkuCode: 'MSP',
  K5SkuCode: 'K5P',
}



// WEBPACK FOOTER //
// ./src/components/SiteSummary/constants.js